import { z } from "zod";
import { createNameSchema } from "../update-profile-schemas";

export const contactFormSchema = z.object({
    firstName: createNameSchema("First name"),
    lastName: createNameSchema("Last name"),

    email: z
        .string()
        .nonempty("Email is required")
        .email("Invalid email address")
        .transform(val => val.toLowerCase().trim())
        .refine(val => val.length <= 320, "Email address is too long")
        .refine(val => {
            const domain = val.split('@')[1];
            return domain && domain.includes('.') && domain.length >= 4;
        }, "Invalid email domain"),

    message: z
        .string()
        .min(10, "Message must be at least 10 characters")
        .max(700, "Message must be less than 700 characters")
        .trim()
        .refine((val) => val.length > 0, {
            message: "Message cannot be only spaces",
        }),
});

export type ContactFormSchema = z.infer<typeof contactFormSchema>;
